<!--  示例：简易字典
  <simple-dict-radio dict-type="userType" v-model="userType" ></simple-dict-radio>
 -->
<template>
  <el-radio-group @change="changeSelect" v-model="selectValue" :disabled="noSelect"  ref="simpleDict">
    <el-radio v-if="!(item.value=='')" v-for="item in options"
               :key="item.value"
               :label="item.value"
               >
      {{item.label}}
    </el-radio>
  </el-radio-group>
</template>

<script>
  export default {
    name: 'simple-dict-radio',
    props: ['dictType', 'value', 'disabled'],
    data () {
      return {
        noSelect: '',
        selectValue:'',
      };
    },
    computed:{
      options(){
        return this.$store.state.dictMap[this.dictType];
      }
    },
    watch: {
      value: function (newValue, oldValue) {
        this.selectValue = newValue+"";
      }
    },
    methods: {
      changeSelect: function (value) {
        console.log(value);
        this.$emit('update:modelValue', value);
      },
      focus:function(){
        this.$refs['simpleDict'].focus();
      }
    },
    mounted () {
      this.selectValue = this.value+"";
      this.noSelect = (this.disabled == '' || this.disabled == 'true');
    }
  }
</script>

<style lang="less" scoped>
  /deep/.el-input__inner{
    height: 32px!important;
  }
</style>
